import call from "@brainspore/celadon-base/service/http";
import RefundConstants from "./RefundConstants";
import { helper } from "../dashboard/utils";
export default {
  namespaced: true,
  state: {
    refunds: [],
    refund: {},
    attachmentDialog: false,
    studentBalance: 0,
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    refundGetter: (state) => (value) => state[value],
  },
  actions: {
    refunds({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", RefundConstants.refund)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "refunds", data: res.data.data });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    saveRefund({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RefundConstants.refund, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully Requested student Refund.");
          dispatch("sendStudentRequestForApproval", {
            requestNo: res.data.data.shift().no,
          });
          dispatch("refunds");
          Event.$emit("route-change", { name: "RefundList" });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getRefund({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      let decrypted = helper.decrypt(payload);
      call("get", RefundConstants.getRefund(decrypted))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "refund",
            data: res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    patchRefund({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RefundConstants.patchRefund, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully Updated Refund Request");
          dispatch("sendStudentRequestForApproval", {
            requestNo: res.data.data.shift().no,
          });
          dispatch("refunds");
          Event.$emit("route-change", { name: "RefundList" });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    deleteRefund({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RefundConstants.deleteRefund, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          dispatch("refunds");
          Event.$emit(
            "ApiSuccess",
            "You've successfully deleted Refund Document",
          );
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    deleteAttachment({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RefundConstants.deleteAttachment, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          dispatch("getRefund", helper.encrypt(payload.documentNo));
          Event.$emit("ApiSuccess", "Successfully deleted Attachment");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    setAttachmentDialog({ commit }, payload) {
      commit("MUTATE", { state: "attachmentDialog", data: payload });
    },
    getStudentPaymentBalance({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", RefundConstants.getStudentPaymentBalance).then((res) => {
        commit("MUTATE", {
          state: "studentBalance",
          data: res.data.data.shift(),
        });
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },
    sendStudentRequestForApproval({ commit, dispatch }, data) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RefundConstants.sendStudentRequestForApproval, data)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          dispatch("refunds");
          Event.$emit(
            "ApiSuccess",
            "Successfully sent Refund Request for approval",
          );
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    cancelStudentApprovalRequest({ commit }, data) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RefundConstants.cancelStudentApprovalRequest, data)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit(
            "ApiSuccess",
            "Successfully cancelled student Refund approval request",
          );
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
